import { create } from 'zustand'
import { api, setToken, getToken } from '../lib/api.js'

export const useAuth = create((set) => ({
  user: null,
  loading: true,
  async hydrate() {
    if (!getToken()) { set({ loading: false }); return }
    try {
      const { user } = await api.me()
      set({ user, loading: false })
    } catch {
      setToken(null)
      set({ user: null, loading: false })
    }
  },
  async login(email, password) {
    const { token, user } = await api.login(email, password)
    setToken(token)
    set({ user })
  },
  async acceptInvite(inviteToken, password) {
    const { token, user } = await api.acceptInvite(inviteToken, password)
    setToken(token)
    set({ user })
  },
  async logout() {
    try { await api.logout() } catch { /* ignore */ }
    setToken(null)
    set({ user: null })
  },
}))
